module.exports = __webpack_public_path__ + "static/media/astronaut.486d6fc5.jpg";